/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();

      this.onColorSwatchClickBound = this.onColorSwatchClick.bind(this);
      this.onColorSwatchMouseEnterBound =
        this.onColorSwatchMouseEnter.bind(this);
      this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
      this.onVariantChangedBound = this.onVariantChanged.bind(this);
      this.check = this.checkState.bind(this);
    }

    connectedCallback() {
      this.colorLabel = this.querySelector("[data-color-swatch-name]");
      this.colorLabelState = this.querySelector("[data-color-swatch-state]");
      this.soldOutString = this.getAttribute("data-swatch-sold-out-string");
      this.productForm =
        this.closest(".product-single-wrapper") || this.closest("#product-box");
      this.colorSwatches = this.querySelectorAll(".swatch-element.color");
      this.textSwatches = this.querySelectorAll(".swatch-element:not(.color)");
      this.checkCheckbox = this.querySelectorAll(
        "#additional-voltage-checkbox"
      );
      this.setEventListeners();
      this.setColorLabelState();
    }

    setEventListeners() {
      this.colorSwatches.forEach((swatch) => {
        swatch.addEventListener("click", this.onColorSwatchClickBound);
        swatch.addEventListener(
          "mouseenter",
          this.onColorSwatchMouseEnterBound
        );
        swatch.addEventListener("mouseleave", this.onSwatchMouseLeaveBound);
      });

      this.checkCheckbox.forEach((box) => {
        box.addEventListener("click", this.check);
      });

      if (this.productForm)
        this.productForm.addEventListener(
          "variant:changed",
          this.onVariantChangedBound
        );
    }

    setColorLabelState() {
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (!activeSwatch) return;

      const activeSwatchAvailable = activeSwatch.getAttribute(
        "data-swatch-option-available"
      );
      if (!this.soldOutString || !this.colorLabelState) return;

      this.colorLabelState.innerText =
        activeSwatchAvailable == "false" ? `(${this.soldOutString})` : "";
    }

    onColorSwatchClick(event) {
      this.updateColorLabel(event.currentTarget);
    }

    onColorSwatchMouseEnter(event) {
      // Update color label
      this.updateColorLabel(event.currentTarget);

      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (activeSwatch && !event.currentTarget.classList.contains("active"))
        activeSwatch.classList.add("sibling-hover-active");
    }

    onSwatchMouseLeave() {
      const siblingHoverActiveSwatch = this.querySelector(
        ".swatch-element.sibling-hover-active"
      );
      if (siblingHoverActiveSwatch)
        siblingHoverActiveSwatch.classList.remove("sibling-hover-active");

      // Reset color label
      this.resetColorLabel();
    }

    updateColorLabel = (swatch) => {
      if (!swatch) return;
      const label = swatch.getAttribute("data-value");
      const swatchAvailable = swatch.getAttribute(
        "data-swatch-option-available"
      );

      if (!label || !this.colorLabel) return;
      this.colorLabel.textContent = label;
      if (this.colorLabelState)
        this.colorLabelState.innerText =
          swatchAvailable == "false" ? `(${this.soldOutString})` : "";
    };

    resetColorLabel = () => {
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (!activeSwatch || !this.colorLabel) return;

      const activeSwatchValue = activeSwatch.getAttribute("data-value");
      const swatchAvailable = activeSwatch.getAttribute(
        "data-swatch-option-available"
      );
      if (!activeSwatchValue) return;

      this.colorLabel.textContent = activeSwatchValue;
      if (this.colorLabelState)
        this.colorLabelState.innerText =
          swatchAvailable == "false" ? `(${this.soldOutString})` : "";
    };

    setActiveClass = (swatch) => {
      if (!swatch) return;
      swatch.classList.add("active");
    };

    removeActiveClass = (swatch) => {
      if (!swatch) return;
      swatch.classList.remove("active");
    };

    checkState = () => {
      const checkbox = document.getElementById("additional-voltage-checkbox");
      if (!checkbox) return;
      const parentElement = checkbox.closest(".swatch-element");
      const addToCartButton = document.getElementById("AddToCart"); // Основная кнопка "Add to Cart"
      const dinamicAddToCartBtn = document.querySelectorAll(
        ".sticky-add__btn #AddToCart"
      ); // Динамическая кнопка

      if (checkbox.checked && parentElement.classList.contains("active")) {
        addToCartButton.disabled = false;
        dinamicAddToCartBtn.forEach(function (element) {
          element.disabled = false;
        });
      } else if (!parentElement.classList.contains("active")) {
        addToCartButton.disabled = false;
        dinamicAddToCartBtn.forEach(function (element) {
          element.disabled = false;
        });
      } else {
        addToCartButton.disabled = true;
        dinamicAddToCartBtn.forEach(function (element) {
          element.disabled = true;
        });
      }
    };

    onVariantChanged(event) {
      if (!event.detail.variant) {
        const product = event.detail.product;
        let selectedVariant;

        if (product.options.length == 3) {
          const selectedOption1 = document.querySelector(
            "input:checked[name='option-1']"
          ).value;
          const selectedOption2 = document.querySelector(
            "input:checked[name='option-2']"
          ).value;
          const selectedOption3 = document.querySelector(
            "input:checked[name='option-3']"
          ).value;

          // find variant where first two options match and is available
          selectedVariant = product.variants.find(
            (v) =>
              v.available &&
              v.options[0] === selectedOption1 &&
              v.options[1] === selectedOption2
          );

          // if not found, find where first option matches and is available
          if (!selectedVariant) {
            selectedVariant = product.variants.find(
              (v) => v.available && v.options[0] === selectedOption1
            );
          }

          // otherwise find first available
          if (!selectedVariant) {
            selectedVariant = product.variants.find((v) => v.available);
          }
        } else if (product.options.length == 2) {
          const selectedOption1 = document.querySelector(
            "input:checked[name='option-1']"
          ).value;

          // find variant where first option matches and is available
          selectedVariant = product.variants.find(
            (v) => v.available && v.options[0] === selectedOption1
          );

          // otherwise find first available
          if (!selectedVariant) {
            selectedVariant = product.variants.find((v) => v.available);
          }
        } else {
          // find first available variant
          selectedVariant = product.variants.find((v) => v.available);
        }

        // Click the option inputs to select the variant
        if (selectedVariant) {
          for (let i = 0; i < product.options.length; i++) {
            document
              .querySelector(
                `[data-option='${product.options[i]}'] input[value='${selectedVariant.options[i]}']`
              )
              ?.click();
          }
        }

        return;
      }

      if (
        event.detail.variant.id == 45930871423028 ||
        event.detail.variant.id == 45930871455796
      ) {
        document
          .querySelector("[data-option='Voltage'] input[value='No Voltage']")
          .click();
        return;
      }

      const productSingleWrapper = this.closest(".product-single-wrapper");
      if (productSingleWrapper) {
        productSingleWrapper.setAttribute(
          "selected-variant-id",
          event.detail.variant.id
        );
      }
      if (
        event.detail.variant.id == 45770500472884 ||
        event.detail.variant.id == 45768682766388 ||
        event.detail.variant.id == 45810787287092
      ) {
        setTimeout(() => {
          document.getElementById("AddToCart").disabled = false;
        }, 200);
      }
      window.dispatchEvent(
        new CustomEvent("variant:changed", { detail: event.detail })
      );
      const product = event.detail.product;

      if (!product) return;

      const variant = event.detail.variant;
      if (!variant) return;

      const swatchSelectedSize = document.querySelector(
        "[data-swatch-selected-size]"
      );
      let sizeIndex = product.options.indexOf("Size");
      if (sizeIndex === -1) {
        sizeIndex = product.options.indexOf("Model");
      }

      const selectedSize = variant[`option${sizeIndex + 1}`];
      if (swatchSelectedSize) {
        swatchSelectedSize.innerHTML = selectedSize;
      }

      // Set active swatches based on the selected variant
      product.options.forEach((option, index) => {
        // Remove active class from all swatches
        const swatches = this.querySelectorAll(
          `.swatch-element[data-option="${option}"]`
        );
        swatches.forEach((swatch) => this.removeActiveClass(swatch));

        // Set active class on the swatch that matches the selected variant
        const swatch = this.querySelector(
          `.swatch-element[data-option="${option}"][data-value='${
            variant[`option${index + 1}`]
          }']`
        );

        if (swatch) this.setActiveClass(swatch);

        this.checkState();
      });

      const activeSwatches = Array.from(
        this.productForm.querySelectorAll(
          ".swatch-element.variant-swatch.active"
        )
      )
        .map((swatch) => swatch.getAttribute("data-value"))
        .filter(Boolean);

      if (activeSwatches.length < product.options.length) return;

      const selectedVariantTitle = activeSwatches.join(" / ");
      const selectedVariant = product.variants.find(
        (variant) => variant.title === selectedVariantTitle
      );
      if (!selectedVariant) return;

      product.options.forEach((option, index) => {
        const optionValues = product.variants.map(
          (variant) => variant[`option${index + 1}`]
        );
        optionValues.forEach((value) => {
          this.updateSwatchStates(
            product,
            value,
            index + 1,
            selectedVariant,
            option
          );
        });
      });
    }

    updateSwatchStates(product, value, optionIndex, currentVariant, option) {
      const availability = product.variants.map((variant) => variant.available);
      const optionValues = [
        product.variants.map((variant) => variant.option1),
        product.variants.map((variant) => variant.option2),
        product.variants.map((variant) => variant.option3),
      ];

      const isOptionAvailable = optionValues[optionIndex - 1].some(
        (optionValue, i) => {
          switch (optionIndex) {
            case 1:
              return optionValue === value && availability[i];
            case 2:
              return (
                optionValue === value &&
                optionValues[0][i] === currentVariant.option1 &&
                availability[i]
              );
            case 3:
              return (
                optionValue === value &&
                optionValues[0][i] === currentVariant.option1 &&
                optionValues[1][i] === currentVariant.option2 &&
                availability[i]
              );
            default:
              return false;
          }
        }
      );

      const swatches = this.productForm.querySelectorAll(
        `.swatch-element.variant-swatch[data-option="${option}"][data-value="${value}"]`
      );
      swatches.forEach((swatch) => {
        if (isOptionAvailable) {
          swatch.classList.remove("soldout");
          swatch.setAttribute("data-swatch-option-available", true);
        } else {
          swatch.classList.add("soldout");
          swatch.setAttribute("data-swatch-option-available", false);
        }
      });

      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (activeSwatch) this.updateColorLabel(activeSwatch);
    }

    removeEventListeners() {
      this.colorSwatches.forEach((swatch) => {
        swatch.removeEventListener("click", this.onColorSwatchClickBound);
        swatch.removeEventListener(
          "mouseenter",
          this.onColorSwatchMouseEnterBound
        );
        swatch.removeEventListener("mouseleave", this.onSwatchMouseLeaveBound);
      });

      if (this.productForm)
        this.productForm.removeEventListener(
          "variant:changed",
          this.onVariantChangedBound
        );
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }
  }

  if (!window.customElements.get("product-swatch")) {
    window.customElements.define("product-swatch", ProductSwatch);
  }

  /******/
})();
